import { useCallback } from 'react';
import { utils as commonUtils } from '@febos-io/common';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../store';

const { Auth } = commonUtils;

export default function useOnSignInFederate() {
  const dispatch = useDispatch();
  return useCallback(async (entity) => {
    try {
      dispatch(setLoading(false));
      
      // Check if there's already a signed-in user
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        if (currentUser) {
          console.log('[useOnSignInFederate] User already authenticated, signing out first');
          await Auth.signOut();
        }
      } catch (error) {
        // No user signed in, continue with federated sign in
        console.log('[useOnSignInFederate] No current user, proceeding with federated sign in');
      }
      
      await Auth.federatedSignIn({ provider: entity });
    } catch (error) {
      commonUtils.errorHandler(error);
      dispatch(setLoading(false));
    }
  }, [dispatch]);
}
